import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        When the COVID-19 pandemic sent colorists, visual effects (VFX) artists, engineers, and the
        rest of the teams that handle postproduction home for lockdown in March 2020, Hollywood’s
        movie (and TV) magic screeched to a halt. On{' '}
        <a
          href="https://Company3.com"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          Company 3’s
        </a>{' '}
        63,000-square-foot Santa Monica, California, campus, a vast array of postproduction
        hardware, VFX workstations, and multiple private screening rooms was suddenly rendered
        unusable as the pandemic and the attendant lockdowns made it nearly impossible to host the
        usual buzzing activity of company employees and their clients. And this was true for Company
        3’s other postproduction studios on multiple continents.
      </p>
    </section>
  );
}

export default Chapter1;
